













































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import { User } from "@/types";
import LeadPaymentDetails from "./PaymentDetails.vue";
import EventTimeline from "./EventTimeline.vue";
import { collections, firestore } from "@/configs/firebase";
import logger from "@/configs/logger";
import { objectify } from "@/helpers";
import logEvent, {
  ProductGroups,
  ProductGroup,
  VerificationType
} from "@/lib/logEvent";

@Component({ components: { LeadPaymentDetails, EventTimeline } })
export default class LeadRequestEsig extends Vue {
  @Prop() lead!: any;
  @State("user") user!: User;
  @Action("requestVerification") requestVerification!: Function;
  @Action("updateLead") updateLead!: Function;

  readyToTransferCheck = false;
  selectedProducts: any[] = [];
  unsubscribe!: Function;

  get verGroups(): ProductGroup[] {
    // think of this as groups of products that are verified/sold together
    // todo: auto generate verification_groups from products.
    return [
      ProductGroups.NIIA_HEALTH,
      ProductGroups.INSURITA_ANCILLARY,
      ProductGroups.DISCOUNT_PLAN
    ];
  }

  get isCloserOrAdmin(): boolean {
    return (
      this.user.roles.includes("admin") || this.user.roles.includes("closer")
    );
  }

  get showReadyToTransfer(): boolean {
    return (
      this.user.roles.includes("verification") ||
      this.user.roles.includes("admin")
    );
  }

  get statusActions() {
    return this.verGroups.map(group => ({
      name: group,
      //actions: ["request_text", "request_email"]
      actions: [
        { name: "Request Text", value: "esig_text" },
        { name: "Request Email", value: "esig_email" }
      ]
    }));
  }

  get canRequestEsig(): boolean {
    return (
      this.completedPaymentDetails &&
      this.selectedProductsHaveEffectiveDate &&
      this.selectedProductsHaveEnrollmentFee &&
      this.isCloserOrAdmin
    );
  }

  get completedPaymentDetails(): boolean {
    const paymentDetails: any = objectify(this.lead.payment_details);
    const dets =
      paymentDetails.credit_card_number || paymentDetails.account_number;
    return !!dets;
  }

  get selectedProductsHaveEffectiveDate(): boolean {
    const products = this.selectedProducts;
    if (!products) return false;
    return (
      Object.values(products).filter((item: any) => !item.effective_date)
        .length < 1
    );
  }

  get selectedProductsHaveEnrollmentFee(): boolean {
    const products = this.selectedProducts;
    if (!products) return false;
    return (
      Object.values(products).filter((item: any) => !item.enrollment_fee)
        .length < 1
    );
  }

  @Watch("lead")
  onLeadUpdate(val: any, prev: any) {
    if (val && prev && val.id !== prev.id) {
      this.getSelectedProducts(val);
    }
  }

  created() {
    this.readyToTransferCheck = this.lead.closer_ready_to_transfer_to_ver;
    this.getSelectedProducts();
  }

  beforeDestroy() {
    this.unsubscribe();
  }

  getSelectedProducts(lead = this.lead) {
    this.unsubscribe && this.unsubscribe();
    if (this.lead && this.lead.id) {
      this.unsubscribe = collections.lead
        .doc(lead.id)
        .collection("selected_products")
        .onSnapshot(snapshot => {
          this.selectedProducts = snapshot.docs.map(doc => ({
            productId: doc.id,
            ...doc.data()
          }));
          logger("log", "selected products:", this.selectedProducts);
        });
    }
  }

  readyToTransfer(val: boolean): void {
    try {
      collections.lead
        .doc(this.lead.id)
        .update({ closer_ready_to_transfer_to_ver: val });
      val &&
        this.$toasted
          .success("You are ready to transfer to verification.")
          .goAway(2000);
    } catch (err) {
      logger("error", "ready to transfer error", err);
      this.$toasted
        .error("Failed to update ready to transfer status.")
        .goAway(2000);
    }
  }

  handleInputChange(key: string, val: string) {
    logger("info", "Updating lead " + key + " " + val);
    if (key == "esig_phone_number") {
      this.updateLead({
        data: { esig_phone_number: val },
        leadId: this.lead.id,
        notify: true
      });
    } else if (key == "esig_email") {
      this.updateLead({
        data: { esig_email: val },
        leadId: this.lead.id,
        notify: true
      });
    }
  }

  async handleVerificationReq(type: VerificationType, group: ProductGroup) {
    if (!this.completedPaymentDetails) return;
    logger("log", "request esig lead id", this.lead.id);
    const firstRequest = !this.lead.verification_requested_ts;
    await this.requestVerification({
      leadId: this.lead.id,
      verificationType: type,
      group: group,
      products: this.getProductsByVerGroup(group),
      firstRequest
    });
  }

  getProductsByVerGroup(group: string) {
    const products: Array<any> = this.selectedProducts || [];
    if (group == ProductGroups.NIIA_HEALTH) {
      return products.filter(product => product.type === "health");
    } else if (group == ProductGroups.DISCOUNT_PLAN) {
      return products.filter(product => product.type == "discount_plan");
    } else {
      return products.filter(
        product => product.type !== "health" && product.type !== "discount_plan"
      );
    }
  }
}
